// @ts-nocheck
import React, {useEffect, useState} from 'react'
import AffiliateShell from './components/AffiliateShell'
import {AFF, card} from './components/affiliateTheme'
import {getAffiliateDashboard, getWhatsappStatus, sendRegisterLink} from './core/_requests'

const AffiliateClientRegisterWrapper = () => {
  const [code, setCode] = useState('')
  const [waStatus, setWaStatus] = useState('disconnected')
  const [copied, setCopied] = useState(false)
  const [phone, setPhone] = useState('')
  const [sending, setSending] = useState(false)
  const [sentMsg, setSentMsg] = useState('')

  useEffect(() => {
    getAffiliateDashboard()
      .then((r) => setCode(r.data?.affiliate_code || ''))
      .catch(() => {})
    getWhatsappStatus()
      .then((r) => setWaStatus(r.data?.status || 'disconnected'))
      .catch(() => {})
  }, [])

  const REGISTER_HOST = 'https://console.fbzipper.com'
  const link = code ? `${REGISTER_HOST}/auth/yad2-register?aff=${encodeURIComponent(code)}` : ''

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link)
      setCopied(true)
      setTimeout(() => setCopied(false), 1800)
    } catch (_) {}
  }

  const send = async () => {
    if (!phone.trim()) return
    setSending(true)
    setSentMsg('')
    try {
      await sendRegisterLink(phone.trim(), REGISTER_HOST)
      setSentMsg('הקישור נשלח ✓')
      setPhone('')
    } catch (e: any) {
      setSentMsg('שליחה נכשלה: ' + (e?.response?.data?.error || e?.message))
    }
    setSending(false)
  }

  const connected = waStatus === 'connected'

  return (
    <AffiliateShell
      title='הרשמת לקוח'
      subtitle='שלחו ללקוח קישור הרשמה — הוא בוחר את הסוכן שלו ביד2, נרשם, ונספר אוטומטית כלקוח שלכם.'
    >
      {/* Shareable link */}
      <div style={{...card, padding: 24, marginBottom: 20}}>
        <div style={{fontWeight: 700, color: AFF.ink, marginBottom: 6}}>קישור ההרשמה שלך</div>
        <div style={{fontSize: 13, color: AFF.muted, marginBottom: 14}}>
          כל מי שנרשם דרך הקישור הזה משויך אליך אוטומטית. הלקוח ממלא פרטים, בוחר את הסוכן שלו ביד2, והנכסים שלו מתחילים להתפרסם.
        </div>
        <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
          <input
            className='form-control'
            readOnly
            dir='ltr'
            value={link}
            style={{flex: 1, minWidth: 240, border: `1px solid ${AFF.border}`, fontWeight: 600}}
            onFocus={(e) => e.target.select()}
          />
          <button
            className='btn'
            disabled={!link}
            onClick={copy}
            style={{background: AFF.accent, color: '#fff', fontWeight: 700}}
          >
            <i className='bi bi-clipboard me-2' />
            {copied ? 'הועתק ✓' : 'העתק'}
          </button>
        </div>
      </div>

      {/* Send via WhatsApp */}
      <div style={{...card, padding: 24}}>
        <div style={{fontWeight: 700, color: AFF.ink, marginBottom: 6}}>שליחה בוואטסאפ</div>
        {connected ? (
          <>
            <div style={{fontSize: 13, color: AFF.muted, marginBottom: 14}}>
              הזינו מספר טלפון של הלקוח והקישור יישלח מהוואטסאפ המחובר שלך.
            </div>
            <div style={{display: 'flex', gap: 8, flexWrap: 'wrap'}}>
              <input
                className='form-control'
                dir='ltr'
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder='050-0000000'
                style={{flex: 1, minWidth: 200, border: `1px solid ${AFF.border}`}}
              />
              <button
                className='btn'
                disabled={sending || !phone.trim()}
                onClick={send}
                style={{background: AFF.success, color: '#fff', fontWeight: 700}}
              >
                <i className='bi bi-whatsapp me-2' />
                {sending ? 'שולח…' : 'שלח קישור'}
              </button>
            </div>
            {sentMsg && <div style={{marginTop: 10, fontSize: 13, color: AFF.ink}}>{sentMsg}</div>}
          </>
        ) : (
          <div style={{fontSize: 14, color: AFF.muted}}>
            כדי לשלוח את הקישור בוואטסאפ צריך לחבר את חשבון הוואטסאפ שלך בעמוד{' '}
            <a href='/affiliate/whatsapp' style={{color: AFF.accent, fontWeight: 700}}>
              וואטסאפ
            </a>
            . בינתיים אפשר להעתיק את הקישור ולשלוח ידנית.
          </div>
        )}
      </div>
    </AffiliateShell>
  )
}

export default AffiliateClientRegisterWrapper
